module.exports = __webpack_public_path__ + "img/personal-data.ab4be6d2.svg";